import { FormValidationsCollection } from "./form-validations-collection";
import { renderErrorMessage } from './form-validation-error-message';

const formSelector = '[data-validate="jquery"]';
const forms = document.querySelectorAll(formSelector);

forms.forEach((form) => {

  form.addEventListener("submit", (event) => {
    let isValid = true;
    const inputsToValidate = form.querySelectorAll('[data-validators]:not(:disabled)');

    // Remove all validation mesagges before validating
    form.querySelectorAll('.validator').forEach((validatorMessage) => validatorMessage.remove())
    form.querySelectorAll(".--invalid").forEach(input => input.classList.remove("--invalid"))

    const isInputsToValidate = () => inputsToValidate.length;
    if (isInputsToValidate()) {
      inputsToValidate.forEach((inputToValidate) => {

        const validatorsData = JSON.parse(inputToValidate.getAttribute("data-validators"));

        validatorsData.forEach((validator) => {

          const { msg = "" } = validator;
          const inputValue = inputToValidate.value;

          const result = validateHandle(validator, inputValue);

          if (!result) {
            inputToValidate.after(renderErrorMessage(msg));
            inputToValidate.closest(".f-text")?.classList.add("--invalid")
            isValid = false;
          }
        });

      });
    }

    if (!isValid) {
      event.preventDefault(); // Prevent submit if form is not valid
    }

  });

});




export const validateHandle = (validator, inputValue) => {
  const { condition: validatorFunction, params = null } = validator;
  const validationsMethods = new FormValidationsCollection();

  return validationsMethods[validatorFunction](inputValue, params);
}
